import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../public/reset.css';
import Router from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './common/less/index.less'
import './assets/fonts/iconfont.css';
import htmlToPdf from './utils/htmlToPdf'
// 引入图片预览插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// import './router/addRouter.js';
// cancelToken中的cancel函数
Vue.$httpRequestList = [];

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(htmlToPdf)
Vue.use(Viewer,{
  defaultOptions: {
    zIndex: 9999
  }
})

// 图片预览配置
Viewer.setDefaults({
  Options: {
    "inline": true,
    "button": true,
    "navbar": true,
    "title": true,
    "toolbar": true,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": true,
    "fullscreen": true,
    "keyboard": true,
    "zIndex": 9999,
    "url": "data-source"
  }
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')